import { pick } from 'ramda';
import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as server from '../server';
import * as helpers from '../helpers';
import * as actions from '../store/actions';

export const useFetchJackpots = () => {
    const dispatch = useDispatch();
    const { country, currencyCode } = useUserSelector(pick(['country', 'currencyCode']));
    const {
        jackpotsCasinoUrl, jackpotsCasino, useServicesCasinoJackpots,
        locationJson, casinoName, useServicesVfJackpots, defaultBingoRegion
    } = useAppSelector(pick([
        'jackpotsCasinoUrl', 'jackpotsCasino', 'useServicesCasinoJackpots',
        'locationJson', 'casinoName', 'useServicesVfJackpots', 'defaultBingoRegion'
    ]));
    const items = locationJson ? locationJson.items : [];
    const regionItem = items
        .find(location => location.currency === currencyCode && location.countryCode === country);
    const bingoRegion = regionItem && regionItem.region || defaultBingoRegion;

    useEffect(() => {
        if (jackpotsCasinoUrl && jackpotsCasino && currencyCode && useServicesCasinoJackpots) {
            server.getJackpots({ jackpotsCasinoUrl, jackpotsCasino, currency: currencyCode })
                .then((xmlDoc) => {
                    const jackpotsData = helpers.parseJackpotsXML(xmlDoc);
                    const casinoJackpots = helpers.parseCasinoJackpots(jackpotsData.gamedata);

                    dispatch(actions.fetchCasinoJackpot({ casinoJackpots }));

                    dispatcher.dispatch('jackpots:casino', jackpotsData);
                });
        }
    }, [useServicesCasinoJackpots, jackpotsCasinoUrl, jackpotsCasino, currencyCode, dispatch]);

    useEffect(() => {
        if (bingoRegion && casinoName && useServicesVfJackpots) {
            server.getBingoJackpots({ bingoRegion, casinoName })
                .then((response) => {
                    dispatch(actions.fetchBingoJackpot({ vfJackpots: response.data }));

                    dispatcher.dispatch('jackpots:vf', response.data);
                });
        }
    }, [useServicesVfJackpots, bingoRegion, casinoName, dispatch]);
};
